// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const large = "SelfIncrementingProgressbar__large__3vJx-";
export const medium = "500";
export const progressLine = "SelfIncrementingProgressbar__progressLine__7fzd6";
export const progressLineWrapper = "SelfIncrementingProgressbar__progressLineWrapper__evF2w";
export const progressPercentage = "SelfIncrementingProgressbar__progressPercentage__3fmbZ";
export const regular = "400";
export const sans = "'sans'";
export const selfIncrementingProgressbar = "SelfIncrementingProgressbar__selfIncrementingProgressbar__-7ftZ";
export const semibold = "600";
export const serif = "'serif'";